document.addEventListener("click", (event) => {
  const trigger = event.target.closest(".accordion__trigger");
  if (!trigger) return;

  const parent = trigger.closest(".accordion__item");
  const root = trigger.closest(".accordion");
  const content = parent?.querySelector(".accordion__content");
  if (!parent || !root || !content) return;

  if (parent.classList.contains("open")) {
    parent.classList.remove("open");
    content.style.maxHeight = null;
    return;
  }

  root.querySelectorAll(".accordion__item").forEach((accItem) => {
    accItem.classList.remove("open");
    const accContent = accItem.querySelector(".accordion__content");
    if (accContent) accContent.style.maxHeight = null;
  });

  parent.classList.add("open");
  content.style.maxHeight = `${content.scrollHeight}px`;
});
